
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Wer an Hypersomnie leidet, fühlt sich trotz ausreichendem und gutem Schlaf am Morgen nicht ausgeruht und muss tagsüber gegen das Einschlafen ankämpfen. Hier braucht es oft eine Nacht im Schlaflabor, um die Ursache zu finden. Das könnte zum Beispiel eine Schlaf­apnoe mit Atemaussetzern sein. `}<br /><br />{`
Ein weiteres Krankheitsbild ist die Narkolepsie. `}<M mdxType="M">{`Bei einer Narkolepsie haben Betroffene das Gefühl, sie hätten drei oder vier Tage hintereinander nicht geschlafen.`}</M>{` Laut Schätzungen ist nur einer von 2000 Menschen davon betroffen. Gemäss Matthew Walker, Professor für Neurowissenschaften und Psychologie an der University of California in Berkeley, ist dieses ungeheure Schlafbedürfnis so problematisch, weil das unwiderstehliche Verlangen nach Schlaf zu allen möglichen Zeitpunkten im Alltag auftauchen kann. In medizinischer Hinsicht sei Narkolepsie eine neurologische Störung, was bedeutet, dass ihre Ursachen im zentralen Nervensystem liegen. Die Behandlungsmethoden für Narkoleptiker sind momentan noch dürftig.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;